import cookieJs from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import instance from "../axios_setup/instance";

import { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { UserContex } from "./App2";
import Classes from "./style/signUp.module.css";

/*---------------------Login From components------------- */
export default function LoginFrom() {
  const navigate = useNavigate();
  const { dispatch } = useContext(UserContex);
  /*----------useState------*/
  const [emailError, setEmailError] = useState("");
  const [pwError, setPwError] = useState("");
  const [checkError, setCheckError] = useState("");
  const [universalError, setUniversalError] = useState("");

  const [loading, setLoading] = useState(false);
  const [loginCheck, setLogingCheck] = useState(false);
  const [loginState, setLoginState] = useState({
    email: "",
    password: "",
  });
  /*---------------------debounce function------------- */
  const debounce = (func, delay) => {
    setTimeout(() => {
      func();
    }, delay);
  };
  /*----------On Change funtion------*/
  let name, value;
  const onChangeFuntion = (e) => {
    name = e.target.name;
    value = e.target.value;
    setLoginState({ ...loginState, [name]: value });
  };

  /*----------On Submit funtion------*/
  const onSubmitFun = async (event) => {
    event.preventDefault();
    const fromData = new FormData();
    fromData.append("email", loginState.email);
    fromData.append("password", loginState.password);
    fromData.append("check", loginCheck);
    try {
      setLoading(true);
      const { data } = await instance.post("/login", fromData);
      setLoading(false);
      /*-------------For Success Response--------------*/
      if (!data.errors) {
        setCheckError("");
        setEmailError("");
        setPwError("");
        //
        const { decoded } = data.success;
        // create cookie
        cookieJs.set("furniture_shop", decoded, { secure: true });
        toast.success("Login Successful...🔥", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // debounce acctually it's not debouce 😁
        debounce(function () {
          // call  dispatch funtion
          dispatch({ type: "USER", payload: true });
          setLoading(false);
          navigate("/home", { replace: true });
        }, 2000);
      }
    } catch (err) {
      /*-------------For Error Response--------------*/
      setLoading(false);
      const { msg } = err.response.data.errors;
      const msgArray = Object.keys(msg);
      /*-------------For email--------------*/

      if (msgArray.includes("email")) {
        setEmailError(msg.email.msg);
      } else {
        setEmailError("");
      }
      /*-------------For PW--------------*/

      if (msgArray.includes("password")) {
        setPwError(msg.password.msg);
      } else {
        setPwError("");
      }
      /*-------------For CHECK--------------*/

      if (msgArray.includes("check")) {
        setCheckError(msg.check.msg);
      } else {
        setCheckError("");
      }
      if (err.response.data.errors.msg) {
        setUniversalError(err.response.data.errors.msg);
      }

      toast.error("Login Failed.", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  return (
    <>
      <form onSubmit={onSubmitFun}>
        <div className="row px-3">
          <label className="mb-1">
            <h6 className="mb-0 text-sm">Email Address</h6>
          </label>
          <input
            className="mb-1"
            type="text"
            name="email"
            placeholder="Enter a valid email address or phone number"
            value={loginState.email}
            onChange={onChangeFuntion}
            autoComplete="off"
            required
          />

          <code
            style={{ fontWeight: "bolder", color: "red", fontSize: "1.3rem" }}
          ></code>
        </div>
        <div className="row px-3">
          <label className="mb-1">
            <h6 className="mb-0 text-sm">Password</h6>
          </label>
          <input
            type="password"
            name="password"
            placeholder="Enter password"
            value={loginState.password}
            onChange={onChangeFuntion}
            autoComplete="off"
            required
          />

          <code
            style={{ fontWeight: "bolder", color: "red", fontSize: "1.3rem" }}
          ></code>
        </div>
        <div className="row px-3 mb-4">
          <div className="custom-control custom-checkbox custom-control-inline">
            <input
              type="checkbox"
              className="form-check-input"
              id="check2"
              name="check"
              checked={loginCheck}
              onChange={(e) => {
                setLogingCheck(e.target.checked);
              }}
              required
            />
            <label
              className="form-check-label"
              htmlFor="check2"
              style={{ paddingLeft: "0.6rem" }}
            >
              Rember me
            </label>
          </div>
          <NavLink to="/thisRandom" className="ml-auto mb-0 text-sm">
            Forgot Password?
          </NavLink>
        </div>
        <p className="credentials_error">
          {emailError || pwError || checkError || universalError}
        </p>
        <div className="row mb-3 px-3">
          <code style={{ fontWeight: "bolder", color: "red" }}></code>
          <button
            type="submit"
            className={Classes.btnSignup}
            disabled={loading}
          >
            {loading ? "Wait.." : "Login"}
          </button>
        </div>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </form>
    </>
  );
}
